import React from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "hr", label: "HR" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "es", label: "ES" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language || "hr";

  return (
    <div className="lang-switcher">
      {languages.map((lng) => (
        <button
          key={lng.code}
          className={
            "lang-btn" + (current.startsWith(lng.code) ? " active" : "")
          }
          onClick={() => i18n.changeLanguage(lng.code)}
        >
          {lng.label}
        </button>
      ))}
    </div>
  );
}
